module.exports = __webpack_public_path__ + "img/o2o12.9e19c2a9.png";